<template>
<v-list-tile-sub-title>
  <span v-if="isExhausted" class="red--text">{{ $t('device.battery_exhausted') }}</span>
  <span v-else><b :class="batteryTextColor">{{ battery }}</b><small class="grey--text">%</small></span>
  <v-icon small :color="batteryIconColor">{{ batteryIcon }}</v-icon>
</v-list-tile-sub-title>
</template>

<script>
export default {
  name: 'DeviceBattery',
  props: {
    battery: {
      type: Number
    }
  },
  data() {
    return {
      rules: [
        v => v <= 20,
        v => v <= 30,
        v => v <= 40,
        v => v
      ],
      batteryIcons: [
        'battery_alert',
        'battery_alert',
        'battery_std',
        'battery_std'
      ],
      batteryIconColors: [
        'red',
        'orange',
        'lime darken-3',
        'green'
      ],
      batteryTextColors: [
        'red--text',
        'orange--text',
        'lime--text text--darken-3',
        'green--text'
      ]
    }
  },
  computed: {
    level() {
      for (let i in this.rules)
        if (this.rules[i](this.battery))
          return i;
    },
    batteryIcon() {
      return this.batteryIcons[this.level];
    },
    batteryIconColor() {
      return this.batteryIconColors[this.level];
    },
    batteryTextColor() {
      return this.batteryTextColors[this.level];
    },
    isExhausted() {
      return this.battery == 0;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceBattery.vue